import { Component, OnInit } from '@angular/core'
import { FormGroup, FormArray, FormControl, FormBuilder } from '@angular/forms'

@Component({
  selector: 'app-company-attendees',
  templateUrl: './company-attendees.component.html',
  styleUrls: ['./company-attendees.component.scss']
})
export class CompanyAttendeesComponent implements OnInit {
  formGroupOfCompanyAttendee: FormGroup
  attendee: Array<Object> = []
  companyContactList: Array<Object> = []
  editableFlag = true
  constructor(private fb: FormBuilder) {}

  ngOnInit() {
    this.formGroupOfCompanyAttendee = this.fb.group({
      inputNames: this.fb.array([])
    })
  }

  get companyAttendees(): FormArray {
    return this.formGroupOfCompanyAttendee.get('inputNames') as FormArray
  }

  async initialCreate() {
    this.companyContactList = this.companyContactList.filter(x => x['status'] === 'Active').map(x => {
      x['label'] = this.prepareCompanyContactDatalist(x)
      return x
    })
    this.formGroupOfCompanyAttendee = this.fb.group({
      inputNames: this.fb.array([null, null, null, null])
    })
  }

  async initialEdit() {
    this.companyContactList = this.companyContactList.filter(x => x['status'] === 'Active').map(x => {
      x['label'] = this.prepareCompanyContactDatalist(x)
      return x
    })
    const companyAttendanceArray = new FormArray([])
    this.attendee.forEach(element => {
      element['label'] = this.prepareCompanyContactDatalist(element)
      element['id'] = element['contactId']
      companyAttendanceArray.push(new FormControl(element))
    })

    if (companyAttendanceArray.length < 1) {
      companyAttendanceArray.push(new FormControl())
    }
    this.formGroupOfCompanyAttendee.setControl(
      'inputNames',
      companyAttendanceArray
    )
  }

  searchCompanyAttendee(term: string, item: Object) {
    return (item['firstName'] + ' ' + item['lastName'])
      .toUpperCase()
      .startsWith(term.toUpperCase())
  }

  prepareCompanyContactDatalist(conpanyContact) {
    return (
      conpanyContact.firstName +
      ' ' +
      conpanyContact.lastName +
      ' - ' +
      conpanyContact.position +
      ' - ' +
      conpanyContact.department
    )
  }

  get getAllCompanyAttendees(): Array<Object> {
    return this.companyAttendees.value
      .filter(element => element !== null)
      .map((element, seq) => {
        return {
          seq: seq + 1,
          contactId: element['id'],
          department: element['department'],
          position: element['position']
        }
      })
  }

  removeAttendee(id) {
    this.companyAttendees.removeAt(id)
  }

  addAttendee() {
    this.companyAttendees.push(new FormControl())
  }

  disableFormControlIfNotPermitted() {
    this.editableFlag = false
    this.formGroupOfCompanyAttendee.disable()
  }
}



// WEBPACK FOOTER //
// /opt/alm/jenkins/workspace/mis-cpm/mis-cpm-prod-front/src/app/crm/company-attendees/company-attendees.component.ts